import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-quill/dist/quill.snow.css";
import "jquery";
import "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import Maintenance from "./components/maintenance-mode";

const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === "true";
const maintenanceEnd = new Date(process.env.REACT_APP_MAINTENANCE_END);

const now = new Date();
const showMaintenance = isMaintenance && now < maintenanceEnd;

ReactDOM.render(
  <BrowserRouter>{showMaintenance ? <Maintenance /> : <App />}</BrowserRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
